
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AboutMissionList',
  props: {
    missionList: {
      type: Array,
      default: () => [],
    },
  },
})
